import React from 'react';
import '../styles/Socials.css';

function Socials(){
    return(
        <div id="socialsRow">
            <p>davidhostalrich.dev@gmail.com</p>
            <a href="https://www.linkedin.com/in/david-hostalrich-jato-2abaaa209" target="_blank" rel="noreferrer">
                <img src={require("../resources/logo_linkedin.png")} alt="logo linkedIn" width={46}/>
            </a>
            <a href="https://github.com/Scrogy" target="_blank" rel="noreferrer">
                <img src={require("../resources/logo_github.png")} alt="logo github" width={46}/>
            </a>
        </div>
    )
}

export default Socials;